// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || '';
